/**
 * Copyright (c) ACT, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

export const E4ECustomDimensions = {
  heights: {
    dialogContainer: 32,
    dialogMargin: 44,
    header: 64,
    tableHeader: 48,
    tablePagination: 58,
  },
  widths: {
    datePickerPopper: 277,
    largeDialog: 872,
    leftNavBar: 72,
    listItemIcon: 40,
    mediumDialog: 648,
    pageMainContent: 1320,
  },
};

export default E4ECustomDimensions;
